import { useEffect, useState } from "react";
const preTest = {
  respondent: 0,
  rate: 0,
};
const postTest = {
  respondent: 0,
  rate: 0,
};
function MatchSuccessRate({ score }) {
  const [preTestRate, setPreTestRate] = useState(preTest);
  const [postTesRate, setPostTestRate] = useState(postTest);
  const [themePre, setThemePre] = useState("progress-bar progress-bar-striped bg-theme");
  const [themePost, setThemePost] = useState("progress-bar progress-bar-striped bg-theme");
  function themeSelect(val) {
    const select = (sc) => {
      if (sc > 80) return "progress-bar progress-bar-striped bg-theme";
      if (sc <= 80 && sc > 50) return "progress-bar progress-bar-striped bg-warning";
      if (sc <= 50) return "progress-bar progress-bar-striped bg-danger";
    };
    const preRate = val.preTest.rate;
    const postRate = val.postTest.rate;
    setThemePre(select(preRate));
    setThemePost(select(postRate));
  }
  useEffect(() => {
    setPreTestRate(score.preTest);
    setPostTestRate(score.postTest);
    themeSelect(score);
  }, [score]);
  return (
    <>
      <div className="mb-1">
        <div className="fs-9px me-2 ms-auto">
          Pre: {preTestRate.rate} % / {preTestRate.respondent} Res.
        </div>
        <div className="progress progress-xs w-80px" style={{ height: "6px" }}>
          <div className={themePre} style={{ width: preTestRate.rate + "%" }}></div>
        </div>
      </div>

      <div className="fs-9px me-2 ms-auto">
        Post: {postTesRate.rate} % / {postTesRate.respondent} res.
      </div>
      <div className="progress progress-xs w-80px" style={{ height: "6px" }}>
        <div className={themePost} style={{ width: postTesRate.rate + "%" }}></div>
      </div>
    </>
  );
}

export default MatchSuccessRate;
